
import { useRoute, useNavigation } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, ScrollView, ActivityIndicator, TouchableOpacity } from 'react-native';
import { Configuration, OpenAI } from "openai";
import { ApiKey } from './ApiKey';




export const Solution = () => {
  const routes = useRoute();
  const navigation = useNavigation();

  const downloadTxtFile = (content) => {
    const element = document.createElement("a");
    const file = new Blob([content], { type: "text/plain" });

    element.href = URL.createObjectURL(file);
    element.download = 'Report';

    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };
  
  const data = routes.params.data;
  const [response, setResponse] = useState("");
  const [running, setRunning] = useState(true);
  const [openai, setOpenai] = useState();

  const finalTemplate = [{
    "role": "system",
    "content": `You are a environnemental assistant.
    You are going to help me reduce my carbon footprint based on my sources and factors of emissions.
    NEVER PROPOSE TO CONSULT PROFESSIONALS.
    You are going to give me a plan to reduce my carbon footprint. Precise in what equipment I should based on my budget.`}, {
    "role": "user", "content": data
  }]


  useEffect(() => {

  }, [])


  useEffect(() => {
    const final = async () => {
      const configuration = new OpenAI({
        apiKey: ApiKey,
        dangerouslyAllowBrowser: true
      });
      setOpenai(configuration)

      setRunning(true);
      const response = await configuration.chat.completions.create({
        messages: finalTemplate,
        model: 'gpt-3.5-turbo',
      });
      const ans = response.choices[0].message.content
      console.log("ans: ", ans);
      setResponse(ans);
      setRunning(false);

    }
    final()
  }, [])


  return (<View style={{ height:'100%', width: "100%", backgroundColor: "white", justifyContent:'center' }}>
    {
      running ? (
        <ActivityIndicator color={"black"} />
      ) : (
        <View style={{ width: "100vw", padding: 20 }}>
          <Text style={{ fontWeight: 'bold', fontSize: 26, marginBottom: 20 }}>Your taylor made solution</Text>
          <TouchableOpacity onPress={() => {
                navigation.navigate("Scope2")
            }}
                style={{
                    position: "absolute",
                    Top: 20,
                    right: 30,
                    backgroundColor: "green",
                    borderRadius: 10,
                    padding: 10,
                    zIndex: 10
                }}>
                <Text style={{ fontWeight: "bold", color: "white" }}>Next</Text>
            </TouchableOpacity>

          <View style={{
            shadowColor: '#171717',
            shadowOpacity: 0.5,
            shadowRadius: 3,
            borderRadius: 10,
            backgroundColor: 'green',
            padding: 10,
          }}>
                      <TouchableOpacity style={{
            position: "absolute",
            bottom: 0,
            right: 30,
            backgroundColor: "green",
            borderRadius: 10,
            padding: 10,
            zIndex: 10,
            maxHeight: 50,
            justifyContent: "center",
            alignItems: "center",
          }} onPress={() => downloadTxtFile(response)}>

            <Text style={{ fontWeight: "bold", color: "white" }}>Download</Text>
          </TouchableOpacity>
            <Text style={{ maxWidth: "100vw", color: 'white', fontWeight: 'bold' }}>{response}</Text>
          </View>
          

        </View>
      )
    }
  </View>
  )
}
